import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Select } from '@crazyegginc/hatch';

import { AUDIENCE_METADATA } from '../../metadata';

export function Comparison({ index, innerIndex }) {
  const { values, errors, setFieldValue } = useFormikContext();
  const condition = values.conditions[index];

  const { hiddenComparison } = AUDIENCE_METADATA[condition.criteria];

  const options = useMemo(() => AUDIENCE_METADATA[condition.criteria].comparisons, [condition.criteria]);

  if (hiddenComparison) return <div className="ml-2.5" />;

  return (
    <div className="w-[100px] mx-2.5 shrink-0">
      <Select
        value={condition.rows[innerIndex].comparison}
        options={options}
        error={errors.conditions?.[index]?.rows?.[innerIndex]?.comparison ?? null}
        onChange={(newValue) => setFieldValue(`conditions[${index}].rows[${innerIndex}].comparison`, newValue)}
        aria-label="comparison"
        renderInPortal={true}
        popperClassName="!z-[100000]"
        buttonClassName="!pl-2.5 !pr-7"
      />
    </div>
  );
}
